var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"default_limit":'500',"default_sort":'id',"default_sort_typ":'DESC',"filter_clearing":true,"extension":''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }